import React, { FunctionComponent, ReactNode } from 'react';

export const SidebarIcon: FunctionComponent<{ icon: ReactNode }> = props => {
  return typeof props.icon === 'string' && props.icon.includes('fa') ? (
    <i className={`nav-icon ${props.icon}`} />
  ) : (
    <div className="nav-icon">{props.icon}</div>
  );
};
